<template>
    <div>
        <div class="d-flex flex-column px-4 pt-4">
            <h3
                v-text="title"
            />
            <span
                v-text="subTitle"
                class="
                    text-smaller
                    text-uppercase
                    text-gray-nickel
                    font-weight-semi-bold
                "
            />
        </div>

        <div class="mt-2 table-responsive">
            <table class="striped">
                <tbody>
                    <tr
                        v-for="(item, index) in data"
                        :key="index"
                    >
                        <td
                            v-text="item.name"
                        />
                        <td
                            v-text="item.value"
                            class="font-weight-bold"
                        />
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WidgetList',
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        subTitle: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
    }
}
</script>
